import { orgSelectors } from 'ducks/orgs'
import DialogEditor from 'projectSections/elements/DialogEditor'
import { Edit, SaveButton, SimpleForm, TextInput, Toolbar } from 'react-admin'
import { useSelector } from 'react-redux'
import { defaultValueFunc, formatSubmitValues, RenderInputs } from 'resources/proposalTemplates/ProposalTemplates'
import { PROPOSAL_V2_PROJECT_LEVEL_FIELDS } from 'resources/proposalTemplates/constants'
import type { ProposalDataType } from 'types/proposals'
import type { RootState } from 'types/state'

type EditProposalTemplateDialogConfig = {
  proposalTemplateId: number
}

const EditProposalTemplateToolbar = (props: any) => {
  return (
    <Toolbar style={{ zIndex: 3, position: 'absolute', bottom: 0, boxSizing: 'border-box', width: '100%' }} {...props}>
      <div>
        <SaveButton
          {...props}
          redirect={false}
          submitOnEnter={false}
          onSave={(values: object, redirect: string, form: any, defaultSaveFunc: Function) => {
            defaultSaveFunc(values, redirect, {
              onSuccess: props.onSuccess,
              onFailure: props.onFailure,
            })
          }}
        />
      </div>
    </Toolbar>
  )
}

const EditProposalTemplateEditor = ({ handleClose, fetchProjectData, projectId, ...rest }: any) => {
  const enableExhibit = useSelector((state: RootState) => orgSelectors.getOrg(state)?.enable_exhibit)

  const handleSaveSuccess = () => {
    handleClose()
    fetchProjectData?.(projectId)
  }

  return (
    <Edit
      style={{ padding: 0 }}
      {...rest}
      basePath={'/proposal_templates'}
      resource={'proposal_templates'}
      hasDelete={false}
      hideBreadCrumbs={true}
      hideTitle={true}
      title={<></>}
      actions={<></>}
    >
      <SimpleForm
        redirect={false}
        // @ts-ignore style prop missing from react-admin fork's prop-types
        style={{ marginBottom: 60 }}
        defaultValue={defaultValueFunc}
        formatSubmitValues={formatSubmitValues}
        keepDirtyOnReinitialize={true}
        toolbar={<EditProposalTemplateToolbar onSuccess={handleSaveSuccess} />}
      >
        <TextInput source="settings" style={{ display: 'none' }} />
        <RenderInputs
          enableExhibit={enableExhibit}
          disabled={false}
          fields={PROPOSAL_V2_PROJECT_LEVEL_FIELDS}
          {...rest}
        />
      </SimpleForm>
    </Edit>
  )
}

export const EditProposalTemplateDialog = ({
  isOpen,
  handleClose,
  config,
  proposalData,
  fetchProjectData,
}: {
  isOpen: boolean
  handleClose: () => void
  config: EditProposalTemplateDialogConfig
  proposalData: ProposalDataType
  fetchProjectData?: (projectId?: number) => void
}) => {
  const projectId = proposalData.selectedProject.id

  return (
    <DialogEditor
      // @ts-ignore
      isOpen={isOpen}
      handleClose={handleClose}
      id={config.proposalTemplateId}
      title="Edit Proposal Template"
      editorComponent={<EditProposalTemplateEditor />}
      editorProps={{ fetchProjectData, projectId }}
      options={{ maxWidth: 'md', fullWidth: true }}
    />
  )
}
